// @flow

import React, { Component } from 'react';
import { DragLayer } from 'react-dnd';
import PuzzlePiece from './PuzzlePiece';
import type { PieceData } from './types';

type Item = {
  pieceData: PieceData,
  number: number,
};

type Offset = {
  y: number,
  x: number,
};

type DragLayerStyle = {
  position?: string,
  pointerEvents?: string,
  position?: string,
  zIndex?: number,
  left?: number,
  top?: number,
  width?: string,
  height?: string,
  WebkitTransform?: string,
};

type Props = {
  item: Item,
  isDragging: boolean,
  currentOffset: ?Offset,
  fieldWidth: number,
};

type CollectData = {
  item: Item,
  itemType: string,
  isDragging: boolean,
  currentOffset: Offset,
};

function collect(monitor: any): CollectData {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getSourceClientOffset(),
  };
}

function renderPiece(item: Item, fieldWidth: number): React$Element<any> {
  return (
    <PuzzlePiece
      pieceData={item.pieceData}
      finished={true}
      field={false}
      fieldWidth={fieldWidth}
    />
  );
}

function translatePosition(currentOffset: ?Offset): DragLayerStyle {
  if (!currentOffset) return { display: 'none' };
  const x = currentOffset.x;
  const y = currentOffset.y;
  const translate = `translate(${x}px, ${y}px)`;
  return {
    pointerEvents: 'none',
    position: 'fixed',
    zIndex: 100,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    translate,
    WebkitTransform: translate,
  };
}

class DraggingPieceLayer extends Component<Props> {
  render(): ?React$Element<any> {
    const { item, isDragging, currentOffset, fieldWidth } = this.props;

    if (!isDragging) return null;

    return (
      <div className="puzzle__dragging-piece" style={translatePosition(currentOffset)}>
        {renderPiece(item, fieldWidth)}
      </div>
    );
  }
}

export default DragLayer(collect)(DraggingPieceLayer);
